<template>
    <div class="specialist-building-distribution-page">
        <div class="loading-spinner-outer" v-if="sending">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Sending, please wait
                </div>
            </div>
        </div>

        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Specialist Building Distribution
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-specialist-building-distribution.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Your trusted Nationwide Partner in Building Plastic</h1>
                <p>
                    At Specialist Building Distribution (SBD), we’re experts in supplying high-quality PVC-U building
                    products to the trade and professional sectors. Since 1988, we’ve supported contractors,
                    housebuilders, and developers with everything they need to
                    get the job done - reliably, efficiently and cost-effectively.
                </p>
            </div>
            <div class="box-2">
                <div class="box-2-col">
                    <div class="box-2-number">75+</div>
                    Branches Nationwide
                </div>
                <div class="box-2-col">
                    <div class="box-2-number">10,000+</div>
                    Compliant Products
                </div>
                <div class="box-2-col">
                    <div class="box-2-number">13</div>
                    Established Local Brands
                </div>
                <div class="box-2-col">
                    <div class="box-2-number">Up to 20</div>
                    Years Product Guarantees
                </div>
            </div>
            <div class="p-3 align-center">
                <a class="btn-primary _lg" @click.prevent="enquiry_box_open = true">
                    Make Enquiry
                </a>
            </div>
            <div class="box-3">
                <p>
                    We offer the familiarity of local service with the strength of a national network. Every branch is
                    part of one connected structure - so no matter the name above the door or on the van, you’ll receive
                    the same expert advice, dependable service and quality products.
                </p>
                <p>
                    Our extensive product range includes fascia, soffits, cladding, guttering, windows, doors,
                    rooflights, conservatories, composite decking and more, all backed by experienced teams who
                    understand your site pressures and timelines.
                </p>
                <p>
                    One unified structure brings the flexibility and familiarity of local branches, backed by the scale,
                    stock and support of a nationwide business. It’s one streamlined supply chain built around your
                    needs - keeping your projects moving, wherever you’re working.
                </p>
            </div>
            <div class="box-4">
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-1" @click="openInteractiveImagePopup(1)">Roofline</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-2" @click="openInteractiveImagePopup(2)">Rainwater Systems</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-3" @click="openInteractiveImagePopup(3)">Conservatories</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-4" @click="openInteractiveImagePopup(4)">Bifold Door</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-5" @click="openInteractiveImagePopup(5)">PVC-U, WPC & Aluminium Decking</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-6" @click="openInteractiveImagePopup(6)">Aluminium & PVC-U Door Systems</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-7" @click="openInteractiveImagePopup(7)">Soil Systems</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-8" @click="openInteractiveImagePopup(8)">Composite Entrance & Fire Doors</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-9" @click="openInteractiveImagePopup(9)">Fabricated Building Components</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-10" @click="openInteractiveImagePopup(10)">Cladding</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-11" @click="openInteractiveImagePopup(11)">Aluminium & PVC-U Window Systems</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-12" @click="openInteractiveImagePopup(12)">Fabricated Canopies</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-13" @click="openInteractiveImagePopup(13)">Window Frames</div>
                <div class="specialist-building-distribution-page-interactive-image-marker _marker-14" @click="openInteractiveImagePopup(14)">Door Frames</div>
                <img src="/images/specialist-building-distribution-page-interactive-image.jpg">
            </div>
            <div class="specialist-building-distribution-coverage-banner">
                <h1>Strategic coverage across the UK</h1>
                <div class="specialist-building-distribution-coverage-banner-steps">
                    <div>
                        <i class="fal fa-location-dot"></i>
                        <strong>Local</strong>
                        <span>Branch Expertise</span>
                    </div>
                    <div class="arrow-divider">
                        <i class="fal fa-arrow-right"></i>
                    </div>
                    <div>
                        <i class="fal fa-network-wired"></i>
                        <strong>Connected</strong>
                        <span>One SBD Network</span>
                    </div>
                    <div class="arrow-divider">
                        <i class="fal fa-arrow-right"></i>
                    </div>
                    <div>
                        <i class="fal fa-truck-fast"></i>
                        <strong>Nationwide</strong>
                        <span>Stock, Fleet & Support</span>
                    </div>
                </div>
            </div>

            <div class="box-5">
                <h1>
                    Why Partner with SBD?
                </h1>
                <div class="box-5-row">
                    <div class="box-5-col1">
                        <ul>
                            <li>
                                <strong>Comprehensive Range</strong>
                                <ul>
                                    <li>
                                        Over 10,000 compliant products in one place
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <strong>National Network</strong>
                                <ul>
                                    <li>
                                        75+ locations for fast, reliable supply
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <strong>Trusted Performance</strong>
                                <ul>
                                    <li>
                                        Long-term guarantees up to 20 years
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <strong>Proven Capability</strong>
                                <ul>
                                    <li>
                                        Supporting contractors, developers, and housebuilders alike
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <strong>Simplified Supply Chain</strong>
                                <ul>
                                    <li>
                                        Reduce complexity, save valuable time
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="box-5-col2">
                        <p>
                            Choosing SBD means gaining a dependable partner committed to delivering quality, efficiency, and peace of mind. Our robust infrastructure, financial stability and extensive industry experience empower your business to confidently meet project demands and build lasting success together.
                        </p>

                    </div>
                </div>
<!--                •	75+ branches offering local support and stock availability-->
<!--                •	Dedicated company-owned fleet ensures reliable delivery-->
<!--                •	Flexible delivery schedules and electronic proof of delivery-->
<!--                •	Nationwide coverage & distribution-->
            </div>
            <div class="p-3 align-center">
                <a class="btn-primary _lg" @click.prevent="enquiry_box_open = true">
                    Make Enquiry
                </a>
            </div>
        </div>

        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">How Can We Help?</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        <p>
                            I’m looking for...
                        </p>
                        <div class="checkboxes">
                            <label class="checkbox">
                                <input type="checkbox" v-model="looking_for_list" value="Products for an upcoming project" name="looking_for_list[]">
                                <span class="checkbox-label">Products for an upcoming project</span>
                            </label>
                            <label class="checkbox">
                                <input type="checkbox" v-model="looking_for_list" value="My nearest branch" name="looking_for_list[]">
                                <span class="checkbox-label">My nearest branch</span>
                            </label>
                            <label class="checkbox">
                                <input type="checkbox" v-model="looking_for_list" value="Technical information" name="looking_for_list[]">
                                <span class="checkbox-label">Technical information</span>
                            </label>
                            <label class="checkbox">
                                <input type="checkbox" v-model="looking_for_list" value="Product guarantees" name="looking_for_list[]">
                                <span class="checkbox-label">Product guarantees</span>
                            </label>
                            <label class="checkbox">
                                <input type="checkbox" v-model="looking_for_list" value="Delivery information" name="looking_for_list[]">
                                <span class="checkbox-label">Delivery information</span>
                            </label>
                            <label class="checkbox">
                                <input type="checkbox" v-model="looking_for_list" value="Help with a project" name="looking_for_list[]">
                                <span class="checkbox-label">Help with a project</span>
                            </label>
                            <label class="checkbox">
                                <input type="checkbox" v-model="looking_for_list" value="A specific SBD brand" name="looking_for_list[]">
                                <span class="checkbox-label">A specific SBD brand</span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Enquiry Message</label>
                        <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                    </div>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 1}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Roofline</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Roofline here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 2}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Rainwater Systems</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Rainwater Systems here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 3}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Conservatories</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Conservatories here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 4}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Bifold Door</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Bifold Door here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 5}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">PVC-U, WPC & Aluminium Decking</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about PVC-U, WPC & Aluminium Decking here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 6}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Aluminium & PVC-U Door Systems</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Aluminium & PVC-U Door Systems here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 7}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Soil Systems</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Soil Systems here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 8}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Composite Entrance & Fire Doors</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Composite Entrance & Fire Doors here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 9}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Fabricated Building Components</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Fabricated Building Components here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 10}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Cladding</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Cladding here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 11}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Aluminium & PVC-U Window Systems</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Aluminium & PVC-U Window Systems here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 12}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Fabricated Canopies</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Fabricated Canopies here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 13}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Window Frames</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Window Frames here
                </div>
            </div>
        </div>

        <div class="modal-window" :class="{'open': open_interactive_marker_num === 14}" @click="open_interactive_marker_num = 0">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="open_interactive_marker_num = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Door Frames</h1>
                </div>
                <div class="modal-content align-center mb-3">
                    Information about Door Frames here
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    data() {
        return {
            enquiry_box_open: false,
            enquiry_message: 'I would like more information about Specialist Building Distribution.',
            sending: false,
            looking_for_list: [],
            open_interactive_marker_num: 0,
        }
    },
    computed: {
        formatted_looking_for_list() {
            if(this.looking_for_list.length > 0){
                return "\n\nI'm looking for: " + this.looking_for_list.join(', ');
            }

            return "";
        }
    },
    methods: {
        sendEnquiry() {
            this.enquiry_box_open = false;
            this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 60,
                'message': this.enquiry_message + this.formatted_looking_for_list,
            }).then((response) => {

                gtag('event', 'enquiry_made', {
                    'event_category': 'enquiries',
                    'event_label': ' enquiry',
                    'value': 'Specialist Building Distribution enquiry',
                });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
        partnerLinkClicked() {
            axios.post('/activity-logs/createActivityLogFromRequest', {
                'activity_log_category_id': 3,
                'description': `Partner Link Clicked - Specialist Building Distribution`,
            });
            gtag('event', 'partner_link_clicked', {
                'event_category': 'link',
                'event_label': 'Specialist Building Distribution partner link clicked',
                'value': 'Specialist Building Distribution partner link clicked',
            });
        },
        openInteractiveImagePopup(num) {
            this.open_interactive_marker_num = num;
        },
    },
};
</script>
